import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'orders-persistence',
  storage: localStorage,
});

export const orderListFilter = atom({
  key: 'orderListFilter',
  default: {
    search: "",
    startDate: "",
    endDate: "",
    orderType: "",
    selected_orderType: "",
    orderStatus: "",
    selected_orderStatus: "",
    paymentMode: "",
    selected_paymentMode: "",
    paymentStatus: "",
    selected_paymentStatus: "",
    brands: [],
    selected_brands: [],
    vendors: [],
  },
  effects_UNSTABLE: [persistAtom],
});

export const orderPaginationState = atom({
  key: 'orderPaginationState',
  default: {
    page: 1,
    limit: 10,
  },
  effects_UNSTABLE: [persistAtom],
});